import React, { useState, useEffect, useRef } from "react";

import "./hint.css";

const Hint = ({
  outerOpen,
  hintHeading,
  hintText,
  openOnMount,
  top,
  right
}) => {
  let hintDivRef = useRef(null);
  const [isOpen, setIsOpen] = useState(openOnMount ? true : false);

  const createMarkup = () => {
    return { __html: hintText };
  };

  const handleOutsideClick = (event) => {
    if (hintDivRef.current.contains(event.target)) {
      return;
    } else {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (outerOpen === true) {
      setIsOpen(true);
    }
  }, [outerOpen]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <div
      className={`hintDivContainer ${
        isOpen ? "hintDivContainer--open" : "hintDivContainer--closed"
      }`}
      style={{ top: top, right: right }}
    >
      <button
        className={`hintDivContainer__toggleBtn ${
          isOpen
            ? "hintDivContainer__toggleBtn--open"
            : "hintDivContainer__toggleBtn--closed"
        }`}
        onClick={() => setIsOpen(isOpen ? false : true)}
      >
        {!isOpen ? (
          <svg
            width="2em"
            height="2em"
            viewBox="0 0 16 16"
            className="hintDivContainer__toggleBtn__svg"
            fill="rgb(50, 102, 180"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"
            />
          </svg>
        ) : null}
      </button>
      <div
        ref={hintDivRef}
        className={`hintDiv ${isOpen ? "hintDiv--open" : "hintDiv--closed"}`}
      >
        <h3 className="hintDiv__heading">{hintHeading}</h3>
        <div
          className="hintDiv__body"
          dangerouslySetInnerHTML={createMarkup()}
        />
        <button className={`hintDiv__okBtn`} onClick={() => setIsOpen(false)}>
          OK
        </button>
      </div>
    </div>
  );
};

export default Hint;

/* 
import React, { useState, useEffect, useRef } from "react";

import "./hint.css";

const Hint = ({
  outerOpen,
  hintHeading,
  hintText,
  openOnMount,
  top,
  right
}) => {
  let hintDivRef = useRef(null);
  const [isOpen, setIsOpen] = useState(openOnMount ? true : false);

  const createMarkup = () => {
    return { __html: hintText };
  };

  useEffect(() => {
    if (outerOpen === true) {
      setIsOpen(true);
    }
  }, [outerOpen]);

  useEffect(() => {
    if (isOpen) {
      hintDivRef.current.style.animation = "hintDivOpenAnimation 1s forwards";
    } else {
      hintDivRef.current.style.animation = "hintDivCloseAnimation .5s forwards";
    }
  }, [isOpen]);

  useEffect(() => {
    if (!openOnMount) {
      hintDivRef.current.style.animation = "";
    }
  }, []);

  return (
    <div
      className={`hintDivContainer ${
        isOpen ? "hintDivContainer--open" : "hintDivContainer--closed"
      }`}
      style={{ top: top, right: right }}
    >
      <button
        className={`hintDivContainer__toggleBtn ${
          isOpen
            ? "hintDivContainer__toggleBtn--open"
            : "hintDivContainer__toggleBtn--closed"
        }`}
        onClick={() => setIsOpen(isOpen ? false : true)}
      >
        {!isOpen ? (
          <svg
            width="2em"
            height="2em"
            viewBox="0 0 16 16"
            className="hintDivContainer__toggleBtn__svg"
            fill="green"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"
            />
          </svg>
        ) : null}
      </button>
      <div
        ref={hintDivRef}
        className={`hintDiv ${isOpen ? "hintDiv--open" : "hintDiv--closed"}`}
      >
        <h3 className="hintDiv__heading">{hintHeading}</h3>
        <p className="hintDiv__body" dangerouslySetInnerHTML={createMarkup()} />
        <button className={`hintDiv__okBtn`} onClick={() => setIsOpen(false)}>
          OK
        </button>
      </div>
    </div>
  );
};

export default Hint;

*/
